var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',[_c('h1',{staticClass:"mb-3"},[_vm._v(" Create "+_vm._s(_vm.locationType.text)+" Location")]),_c('LocationForm',{ref:"locationForm",on:{"save":_vm.save,"cancel":_vm.cancel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }